import { render } from "./PropertyItemUser.vue?vue&type=template&id=0f18addf&scoped=true"
import script from "./PropertyItemUser.vue?vue&type=script&lang=js"
export * from "./PropertyItemUser.vue?vue&type=script&lang=js"

import "./PropertyItemUser.vue?vue&type=style&index=0&id=0f18addf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f18addf"]])

export default __exports__